var DOWN_ARROW, ENTER, ESCAPE, KEYLIST, Keypress, LEFT_ARROW, RIGHT_ARROW, TAB, UP_ARROW, base, base1, isCharKeyPress, isDownArrowKey, isEnterKey, isEscapeKey, isTabKey, isUpArrowKey, isValidCharKeyPress, isValidKeyPress, whichKeyAlias;

TAB = 9;

ENTER = 13;

ESCAPE = 27;

DOWN_ARROW = 40;

RIGHT_ARROW = 39;

UP_ARROW = 38;

LEFT_ARROW = 37;

KEYLIST = {
  9: 'Tab',
  13: 'Enter',
  27: 'Escape',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown'
};

isTabKey = function(key) {
  return key === TAB;
};

isEnterKey = function(key) {
  return key === ENTER;
};

isEscapeKey = function(key) {
  return key === ESCAPE;
};

isUpArrowKey = function(key) {
  return key === UP_ARROW;
};

isDownArrowKey = function(key) {
  return key === DOWN_ARROW;
};


/*
 * Assert if key pressed is a normal character key
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key pressed is a normal character key
 */

isValidCharKeyPress = function(e) {
  if (e.which == null) {
    return false;
  }
  if (!isCharKeyPress(e)) {
    return false;
  }
  if (!isValidKeyPress(e.which)) {
    return false;
  }
  return true;
};


/*
 * Assert if key code is valid
 * and wasn't pressed with extra control keys
 *
 * @param   {Object}  e - Event
 * @returns {Boolean}   - Assert if key wasn't pressed with control keys
 */

isCharKeyPress = function(e) {
  if (typeof e.which === 'number' && e.which > 0) {
    return !e.ctrlKey && !e.metaKey && !e.altKey;
  }
  return false;
};


/*
 * Assert if key code is a navigational key
 *
 * @param   {Number}  key - Key code
 * @returns {Boolean}     - Assert if key is not a navigational key
 */

isValidKeyPress = function(key) {
  return !(key === TAB || key === ENTER || key === ESCAPE || key === UP_ARROW || key === DOWN_ARROW || key === LEFT_ARROW || key === RIGHT_ARROW);
};


/*
 * Returns the key name according to the Keyboard API specs
 * NOTE: e.key is not supported in Safari thus fallback to alias list
 *
 * @param   {Object} e - jQuery event
 * @returns {String}   - Key name
 */

whichKeyAlias = function(e) {
  return e.key || KEYLIST[e.which] || '';
};

module.exports = Keypress = {
  isCharKeyPress: isCharKeyPress,
  isDownArrowKey: isDownArrowKey,
  isEnterKey: isEnterKey,
  isEscapeKey: isEscapeKey,
  isTabKey: isTabKey,
  isUpArrowKey: isUpArrowKey,
  isValidCharKeyPress: isValidCharKeyPress,
  isValidKeyPress: isValidKeyPress,
  whichKeyAlias: whichKeyAlias
};

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).Common == null) {
  base1.Common = {};
}

_.extend(window.Groupon.Modules.SearchBar.Common, {
  Keypress: Keypress
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL2NvbW1vbi9tX2tleXByZXNzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC9jb21tb24vbV9rZXlwcmVzcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxHQUFBLEdBQWM7O0FBQ2QsS0FBQSxHQUFjOztBQUNkLE1BQUEsR0FBYzs7QUFFZCxVQUFBLEdBQWM7O0FBQ2QsV0FBQSxHQUFjOztBQUNkLFFBQUEsR0FBYzs7QUFDZCxVQUFBLEdBQWM7O0FBRWQsT0FBQSxHQUNFO0VBQUEsQ0FBQSxFQUFJLEtBQUo7RUFDQSxFQUFBLEVBQUksT0FESjtFQUVBLEVBQUEsRUFBSSxRQUZKO0VBR0EsRUFBQSxFQUFJLFdBSEo7RUFJQSxFQUFBLEVBQUksU0FKSjtFQUtBLEVBQUEsRUFBSSxZQUxKO0VBTUEsRUFBQSxFQUFJLFdBTko7OztBQVNGLFFBQUEsR0FBaUIsU0FBQyxHQUFEO1NBQVMsR0FBQSxLQUFPO0FBQWhCOztBQUNqQixVQUFBLEdBQWlCLFNBQUMsR0FBRDtTQUFTLEdBQUEsS0FBTztBQUFoQjs7QUFDakIsV0FBQSxHQUFpQixTQUFDLEdBQUQ7U0FBUyxHQUFBLEtBQU87QUFBaEI7O0FBQ2pCLFlBQUEsR0FBaUIsU0FBQyxHQUFEO1NBQVMsR0FBQSxLQUFPO0FBQWhCOztBQUNqQixjQUFBLEdBQWlCLFNBQUMsR0FBRDtTQUFTLEdBQUEsS0FBTztBQUFoQjs7O0FBRWpCOzs7Ozs7O0FBTUEsbUJBQUEsR0FBc0IsU0FBQyxDQUFEO0VBQ3BCLElBQW9CLGVBQXBCO0FBQUEsV0FBTyxNQUFQOztFQUNBLElBQWdCLENBQUksY0FBQSxDQUFlLENBQWYsQ0FBcEI7QUFBQSxXQUFPLE1BQVA7O0VBQ0EsSUFBZ0IsQ0FBSSxlQUFBLENBQWdCLENBQUMsQ0FBQyxLQUFsQixDQUFwQjtBQUFBLFdBQU8sTUFBUDs7U0FFQTtBQUxvQjs7O0FBUXRCOzs7Ozs7OztBQU9BLGNBQUEsR0FBaUIsU0FBQyxDQUFEO0VBQ2YsSUFBRyxPQUFPLENBQUMsQ0FBQyxLQUFULEtBQWtCLFFBQWxCLElBQStCLENBQUMsQ0FBQyxLQUFGLEdBQVUsQ0FBNUM7QUFDRSxXQUFPLENBQUMsQ0FBQyxDQUFDLE9BQUgsSUFBYyxDQUFDLENBQUMsQ0FBQyxPQUFqQixJQUE0QixDQUFDLENBQUMsQ0FBQyxPQUR4Qzs7U0FFQTtBQUhlOzs7QUFLakI7Ozs7Ozs7QUFNQSxlQUFBLEdBQWtCLFNBQUMsR0FBRDtTQUNoQixDQUFJLENBQUMsR0FBQSxLQUNILEdBREcsSUFBQSxHQUFBLEtBRUgsS0FGRyxJQUFBLEdBQUEsS0FHSCxNQUhHLElBQUEsR0FBQSxLQUlILFFBSkcsSUFBQSxHQUFBLEtBS0gsVUFMRyxJQUFBLEdBQUEsS0FNSCxVQU5HLElBQUEsR0FBQSxLQU9ILFdBUEU7QUFEWTs7O0FBWWxCOzs7Ozs7OztBQU9BLGFBQUEsR0FBZ0IsU0FBQyxDQUFEO1NBQ2QsQ0FBQyxDQUFDLEdBQUYsSUFBUyxPQUFRLENBQUEsQ0FBQyxDQUFDLEtBQUYsQ0FBakIsSUFBNkI7QUFEZjs7QUFHaEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIsUUFBQSxHQUFXO0VBQzFCLGdCQUFBLGNBRDBCO0VBRTFCLGdCQUFBLGNBRjBCO0VBRzFCLFlBQUEsVUFIMEI7RUFJMUIsYUFBQSxXQUowQjtFQUsxQixVQUFBLFFBTDBCO0VBTTFCLGNBQUEsWUFOMEI7RUFPMUIscUJBQUEsbUJBUDBCO0VBUTFCLGlCQUFBLGVBUjBCO0VBUzFCLGVBQUEsYUFUMEI7Ozs7TUFjTixDQUFDLFlBQWE7Ozs7T0FDSixDQUFDLFNBQVU7OztBQUMzQyxDQUFDLENBQUMsTUFBRixDQUFTLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLFNBQVMsQ0FBQyxNQUExQyxFQUFrRDtFQUFDLFVBQUEsUUFBRDtDQUFsRCJ9
